import { render, staticRenderFns } from "./ApprovalsPage.vue?vue&type=template&id=0aab2790"
import script from "./ApprovalsPage.vue?vue&type=script&lang=js"
export * from "./ApprovalsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports